import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/new_ui/Modal/Modal';

import {
  Nav, Tab, Accordion,
} from 'react-bootstrap5';

import useLastAssessment from 'components/Common/Managers/Hooks/useLastAssessment';

import Summary from 'components/Members/TalentAssessment/Views/Show/Summary';
import Details from 'components/Members/TalentAssessment/Views/Show/Details';

import IconWithText from 'components/Widgets/IconWithText';

export default function Assessment({ member, onClose }) {
  const talentAssessment = useLastAssessment(member.id);

  return (
    <Modal header={member.attributes.full_name} onHide={onClose} show size="xl">
      {talentAssessment && (
      <Tab.Container
        id="talent-assessment-report"
        defaultActiveKey="talent-assessment-summary"
      >
        <Nav fill justify variant="tabs">
          <Nav.Item>
            <Nav.Link eventKey="talent-assessment-summary" className="icon-with-text">
              <i className="summary-icon" />
              <div className="text-content">
                Summary
              </div>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey="talent-assessment-productivity" className="icon-with-text">
              <i className="productivity-icon" />
              <div className="text-content">
                Productivity
              </div>
            </Nav.Link>
          </Nav.Item>

          <Nav.Item>
            <Nav.Link eventKey="talent-assessment-wellbeing" className="icon-with-text">
              <i className="wellbeing-icon" />
              <div className="text-content">
                Wellbeing
              </div>
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Accordion defaultActiveKey="talent-assessment-summary">
          <Tab.Content>
            <Tab.Pane eventKey="talent-assessment-summary" className="px-sm-4 px-xxl-5">
              <Accordion.Item eventKey="talent-assessment-summary">
                <Accordion.Header>
                  <IconWithText
                    iconClassName="summary-icon"
                    wrapperClassName="ms-2"
                  >
                    Summary
                  </IconWithText>
                </Accordion.Header>

                <Accordion.Body>
                  <Summary talentAssessment={talentAssessment} />
                </Accordion.Body>
              </Accordion.Item>
            </Tab.Pane>

            <Tab.Pane eventKey="talent-assessment-productivity" className="px-sm-4 px-xxl-5">
              <Accordion.Item eventKey="talent-assessment-productivity">
                <Accordion.Header>
                  <IconWithText
                    iconClassName="productivity-icon"
                    wrapperClassName="ms-2"
                  >
                    Productivity
                  </IconWithText>
                </Accordion.Header>

                <Accordion.Body>
                  <Details collection={talentAssessment.attributes.productivity_summary} />
                </Accordion.Body>
              </Accordion.Item>
            </Tab.Pane>

            <Tab.Pane eventKey="talent-assessment-wellbeing" className="px-sm-4 px-xxl-5">
              <Accordion.Item eventKey="talent-assessment-wellbeing">
                <Accordion.Header>
                  <IconWithText
                    iconClassName="wellbeing-icon"
                    wrapperClassName="ms-2"
                  >
                    Wellbeing
                  </IconWithText>
                </Accordion.Header>

                <Accordion.Body>
                  <Details collection={talentAssessment.attributes.wellbeing_summary} />
                </Accordion.Body>
              </Accordion.Item>
            </Tab.Pane>
          </Tab.Content>
        </Accordion>
      </Tab.Container>
      )}
    </Modal>
  );
}

Assessment.propTypes = {
  member: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
